import { Group, type GroupProps } from "@mantine/core"
import { TimeInput } from "@mantine/dates"
import type { UseFormReturnType } from "@mantine/form"
import { useTranslation } from "react-i18next"
import { TimezoneInput } from "./TimezoneInput"

interface IProps extends GroupProps {
  tzField?: string
  timeField?: string
  required?: boolean
  form: UseFormReturnType<any>
  disabled?: boolean
}

export function TimeInputs({ form, timeField = "time", tzField = "tz", required, disabled, ...props }: IProps) {
  const { t } = useTranslation()

  return (
    <Group w="100%" wrap="nowrap" {...props}>
      <TimeInput
        {...form.getInputProps(timeField)}
        label={t("Time")}
        flex={1}
        required={required}
        disabled={disabled}
      />
      <TimezoneInput
        {...form.getInputProps(tzField)}
        label={t("Timezone")}
        flex={4}
        required={required}
        disabled={disabled}
      />
    </Group>
  )
}
